// src/utils/eventAssignees.js — GENERATED from functions/utils/eventAssignees.js. DO NOT EDIT BY HAND.
// Regenerate: node functions/scripts/buildEventAssigneesCopies.js   (phone16-7c2e9a41)
// src/utils/eventAssignees.test.js fails if this file is not exactly what the generator writes.
// What this does and why (apptassign-6e1c9b47): see the header of functions/utils/eventAssignees.js.

/* eslint-disable */

// EVENTASSIGNEES-BODY-START
// The event types that are not Jobs. Time Off never opens in the event forms.
const NON_JOB_EVENT_TYPES = ['Appointment', 'Phone Appointment', 'Follow-Up'];

const isNonJobEventType = (eventType) => NON_JOB_EVENT_TYPES.indexOf(eventType) >= 0;

// Rebuild labor rows for an existing event that arrived with people assigned but no
// labor entries (Weekly Planner / route group jobs, server-made Follow-Ups, mobile jobs
// before anyone clocks in). Without this, the save derives assignedTo from an empty list
// and wipes the assignment. hours:0 books no labor; rate:null lets the stampJobLaborRates
// trigger resolve the cost rate server-side. Only ever used on edit (an existing event) —
// create keeps its techSelfSeed. Moved verbatim from JobFormModal (apptassign-6e1c9b47) so
// the reopen path is tested by the same function the form runs.
const reconstructLaborEntriesFromAssignments = (job, emps) => {
    const ids = Array.isArray(job?.assignedTo) ? job.assignedTo : [];
    const names = Array.isArray(job?.assignedToNames) ? job.assignedToNames : [];
    return ids
        .filter(uid => !!uid)
        .map((uid, i) => ({
            userId: uid,
            name: names[i] || emps?.find(e => e.id === uid)?.name || '',
            rate: null,
            hours: 0,
        }));
};

// Who the event is assigned to at save time.
//   - A Job, or a non-Job with someone ticked (and the labour read did not fail): the rows.
//   - A non-Job with nobody ticked: the stored value, else jobData's, else the person saving —
//     so an event is never saved invisible on the calendar.
//   - The save-time labour re-read FAILED: the rows are not written, so assignedTo must not move.
const resolveSaveAssignees = ({
    isNonJobSave,
    mergedLaborEntries,
    liveReadFailed,
    jobToEdit,
    jobData,
    currentUserProfile,
}) => {
    const rows = Array.isArray(mergedLaborEntries) ? mergedLaborEntries : [];

    // Jobs — byte-for-byte the previous expression (jobedit-nostomp-7c3f1a58).
    // Non-Jobs with someone ticked take the same path.
    if (!isNonJobSave || (!liveReadFailed && rows.length > 0)) {
        return {
            assignedTo: rows.map(entry => entry.userId),
            assignedToNames: rows.map(entry => entry.name),
        };
    }

    // Non-Job, nobody ticked (or the labour read failed) — the previous chain, unchanged.
    return {
        assignedTo: jobToEdit?.assignedTo?.length > 0
            ? jobToEdit.assignedTo
            : jobData?.assignedTo?.length > 0
                ? jobData.assignedTo
                : [currentUserProfile.id],
        assignedToNames: jobToEdit?.assignedToNames?.length > 0
            ? jobToEdit.assignedToNames
            : jobData?.assignedToNames?.length > 0
                ? jobData.assignedToNames
                : [currentUserProfile.name || ''],
    };
};

// phone16-7c2e9a41 — the starting rows of a NEW event. A non-Job starts with the person booking it
// ticked (web and phone alike); a Job keeps the form's own seed exactly (a tech's self-seed, else none).
// Existing events never come through here.
const bookerLaborRow = (booker) => ({ userId: booker.id, name: booker.name || '', rate: null, hours: 0 });

const newEventLaborSeed = ({ eventType, booker, jobSeed }) => {
    const seed = Array.isArray(jobSeed) ? jobSeed.map(r => ({ ...r })) : [];
    if (!isNonJobEventType(eventType) || seed.length > 0) return seed;
    return booker && booker.id ? [bookerLaborRow(booker)] : [];
};

// phone16-7c2e9a41 — a row the phone never removes: clocked time. The web form can't untick it either
// (handleEmployeeAssignToggle). A manual row goes when its person is unticked, exactly as on the web —
// the web's own tick writes hours: 1, so locking manual hours would lock every web-ticked person.
const isLockedLaborRow = (row) => !!row && !!row.userId && row.source === 'clocked';

const lockedAssigneeIds = (rows) => {
    const out = [];
    (Array.isArray(rows) ? rows : []).forEach(r => {
        if (isLockedLaborRow(r) && out.indexOf(r.userId) < 0) out.push(r.userId);
    });
    return out;
};

// phone16-7c2e9a41 — the labour rows that match a new list of people, built from the rows as they stand
// NOW (re-read at save time). Clocked rows always stay, first (as the web form's merge puts them); each
// picked person keeps their own row if they have one, else gets a 0-hour row (what the web's reopen
// rebuilds for a phone-made event). Everyone else's manual row goes — exactly what unticking does on the web.
const laborRowsForAssignees = ({ liveRows, people }) => {
    const live = (Array.isArray(liveRows) ? liveRows : []).filter(r => r && r.userId);
    const out = [];
    const seen = [];
    live.forEach(r => {
        if (r.source === 'clocked' && seen.indexOf(r.userId) < 0) { seen.push(r.userId); out.push({ ...r }); }
    });
    (Array.isArray(people) ? people : []).forEach(p => {
        if (!p || !p.userId || seen.indexOf(p.userId) >= 0) return;
        seen.push(p.userId);
        const own = live.find(r => r.userId === p.userId);
        out.push(own ? { ...own } : { userId: p.userId, name: p.name || '', rate: null, hours: 0 });
    });
    return out;
};

// phone16-7c2e9a41 — the same people, in any order (empty ids ignored).
const sameAssignees = (a, b) => {
    const x = (Array.isArray(a) ? a : []).filter(Boolean);
    const y = (Array.isArray(b) ? b : []).filter(Boolean);
    return x.length === y.length && x.every(id => y.indexOf(id) >= 0) && y.every(id => x.indexOf(id) >= 0);
};

// phone16-7c2e9a41 — mirrors firestore.rules: jobCosting is writable through isOffice() or ownsCustomer()
// (the customer's sales_person_id), never through the assigned-user paths (techJobCostingSafe).
const EVENT_LABOR_WRITE_ROLES = ['Office Staff', 'Admin', 'Manager', 'Owner/System Admin', 'Owner / System Admin', 'Owner', 'System Admin'];

const canWriteEventLabor = ({ role, uid, customerSalesPersonId }) =>
    EVENT_LABOR_WRITE_ROLES.indexOf(role) >= 0
    || (role === 'Sales Consultant' && !!uid && customerSalesPersonId === uid);
// EVENTASSIGNEES-BODY-END

export { NON_JOB_EVENT_TYPES, isNonJobEventType, reconstructLaborEntriesFromAssignments, resolveSaveAssignees, bookerLaborRow, newEventLaborSeed, isLockedLaborRow, lockedAssigneeIds, laborRowsForAssignees, sameAssignees, canWriteEventLabor };
